const Empty = require('constants/empty');

const userSelector = store => store.user || Empty.Object;

module.exports = { userSelector };
